import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';
import type { Chat } from '@trinity/chat';
import { ActiveChatSessionContext, ChatSessionFiltersContext } from '../context';
import { useScrollToBottomOfMessages } from './useScrollMessageList';

type MutationVars = {
  identifier: string;
  sourceQuery: Chat.Query;
};

export const useRegenerateQueryMutation = () => {
  const chat = useContext(ActiveChatSessionContext);
  const filters = useContext(ChatSessionFiltersContext);
  const dispatch = useContext(ChatStateDispatchContext);
  const scrollToBottom = useScrollToBottomOfMessages();
  const brandIdentifier = useActiveBrandIdentifier();

  const apiClient = useChatApiClient();

  const mutation = useMutation({
    mutationKey: ['chat:message:regenerate'],
    mutationFn: (vars: MutationVars) => {
      return apiClient.chat.regenerateQuery({
        chatIdentifier: chat.identifier,
        identifier: vars.identifier,
        parentQueryIdentifier: vars.sourceQuery.mapping.parentIdentifier,
        query: vars.sourceQuery.value,
        context: chat.context,
        filters,
        brandIdentifier,
      });
    },
    onMutate: vars => {
      dispatch({
        type: 'query-variant-submitted',
        payload: {
          attachments: [],
          chatIdentifier: chat.identifier,
          identifier: vars.identifier,
          sourceIdentifier: vars.sourceQuery.identifier,
          hideUserMessage: false,
          brandIdentifier,
        },
      });
      scrollToBottom();
    }, onError: (error: AxiosError<AxiosResponse>, vars) => {
      if (error.response?.status === 504 || error.status === 504) {
        return;
      }

      const traceId = error.response?.headers['x-sentry-trace-id'] as string;
      dispatch({
        type: 'query-variant-errored',
        payload: {
          langfuseTraceUrl: null,
          queryIdentifier: vars.identifier,
          sourceIdentifier: vars.sourceQuery.identifier,
          traceId,
        },
      });
      scrollToBottom();
    },
    onSuccess: (data, vars) => {
      // dispatch({
      //   type: 'query-variant-response-available',
      //   payload: {
      //     chatInstance: data.chatInstance,
      //     query: data.query,
      //     sourceIdentifier: vars.sourceQuery.identifier,
      //   },
      // });
      // scrollToBottom();
    },
  });

  return mutation;
};